export const __HiringDetailLang = {
    related: 'فرصت‌های شغلی مشابه',
    viewAll: 'مشاهده همه +',
    share: 'اشتراک گذاری',
    detail: 'مشخصات آگهی استخدام',
    copyAlert: 'لینک آگهی استخدام با موفقیت در کلیپ بورد شما ذخیره شد.',
};
